'use strict';

(function () {
  'use strict';

  angular.module('vnext').config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('vnext.content.settings', {
      url: 'settings',
      controller: 'SettingsCtrl',
      controllerAs: 'vm',
      resolve: {
        components: ['MetadataSvc', function (MetadataSvc) {
          return MetadataSvc.fetchProfileComponents();
        }],
        user: ['$state', 'userSvc', function ($state, userSvc) {
          return userSvc.getUser(true).then(function (user) {
            return user;
          }, function () {
            $state.go('error', {
              message: 'A networking error occurred'
            });
          });
        }],
        pane: function pane() {
          return 'profile';
        }
      },
      data: {
        pageTitle: 'pageTitles.profile'
      },
      templateUrl: 'vnext/pages/settings/settings.html'
    }).state('vnext.content.settingsCustomization', {
      url: 'settings/customization',
      controller: 'SettingsCtrl',
      controllerAs: 'vm',
      resolve: {
        components: ['MetadataSvc', function (MetadataSvc) {
          return MetadataSvc.fetchProfileComponents();
        }],
        user: ['$state', 'userSvc', function ($state, userSvc) {
          return userSvc.getUser(true).then(function (user) {
            return user;
          }, function () {
            $state.go('error', {
              message: 'A networking error occurred'
            });
          });
        }],
        pane: function pane() {
          return 'customization';
        }
      },
      data: {
        pageTitle: 'pageTitles.profile'
      },
      templateUrl: 'vnext/pages/settings/settings.html'
    });
  }]);
})();